/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Spanish (International)
export default {
  'navigation.global-shortcuts.all-sites': 'Todos los sitios',
  'navigation.global-shortcuts.apps.align': 'Align',
  'navigation.global-shortcuts.apps.analytics': 'Análisis',
  'navigation.global-shortcuts.apps.assets': 'Activos',
  'navigation.global-shortcuts.apps.bitbucket': 'Bitbucket',
  'navigation.global-shortcuts.apps.company-hub': 'Centro empresarial',
  'navigation.global-shortcuts.apps.compass': 'Compass',
  'navigation.global-shortcuts.apps.confluence': 'Confluence',
  'navigation.global-shortcuts.apps.focus': 'Focus',
  'navigation.global-shortcuts.apps.goals': 'Metas',
  'navigation.global-shortcuts.apps.home': 'Inicio',
  'navigation.global-shortcuts.apps.jira': 'Jira',
  'navigation.global-shortcuts.apps.jira-product-discovery': 'Jira Product Discovery',
  'navigation.global-shortcuts.apps.jira-service-management': 'Jira Service Management',
  'navigation.global-shortcuts.apps.loom': 'Loom',
  'navigation.global-shortcuts.apps.opsgenie': 'Opsgenie',
  'navigation.global-shortcuts.apps.projects': 'Proyectos',
  'navigation.global-shortcuts.apps.studio': 'Estudio',
  'navigation.global-shortcuts.apps.talent': 'Talent',
  'navigation.global-shortcuts.apps.teams': 'Equipos',
  'navigation.global-shortcuts.apps.trello': 'Trello',
  'navigation.global-shortcuts.menu-expand-item.close-button-aria-label': 'Cerrar',
  'navigation.global-shortcuts.menu-expand-item.site-aria-label': 'Sitio {name}',
  'navigation.global-shortcuts.menu-link-item.disabled-item-aria-label': '(no disponible en estos momentos)',
  'navigation.global-shortcuts.menu-link-item.link-external-item-label': 'Abrir icono de enlace externo',
  'navigation.global-shortcuts.menu-link-item.loading-item-aria-label': '(cargando)',
  'navigation.global-shortcuts.menu-loading-item.loading-item-aria-label': '(cargando)',
  'navigation.global-shortcuts.shortcut-action.open-menu-label': 'abrir menú',
  'navigation.global-shortcuts.sites': 'Sitios de {productName}',
};
